import * as Objdict from "objdict"
import Unit from "@frog/source/models/Unit.js"

export default class Delta {
    static editUnit(unit, deltaunit) {
        if(deltaunit.health != undefined) {
            unit.health += deltaunit.health
            unit.health = Math.min(unit.health, unit.maxhealth)
            unit.health = Math.max(unit.health, 0)
        }
        if(deltaunit.isDead != undefined) {
            unit.isDead = deltaunit.isDead
        }
        if(deltaunit.hasEscaped != undefined) {
            unit.hasEscaped = deltaunit.hasEscaped
        }
        if(deltaunit.position != undefined) {
            if(deltaunit.position.mode == "relative"
            || deltaunit.position.mode == undefined) {
                unit.position.x += deltaunit.position.x || 0
                unit.position.y += deltaunit.position.y || 0
                unit.position.z += deltaunit.position.z || 0
            } else if(deltaunit.position.mode == "absolute") {
                if(deltaunit.position.x != undefined) {
                    unit.position.x = deltaunit.position.x
                }
                if(deltaunit.position.y != undefined) {
                    unit.position.y = deltaunit.position.y
                }
                if(deltaunit.position.z != undefined) {
                    unit.position.z = deltaunit.position.z
                }
            }
            // TODO: RE-CALCULATE TRAP ZONES?? OR CANCEL
            // POSITIONING-BASED EFFECTS LIKE BIND??
        }
        if(deltaunit.energy != undefined) {
            if(deltaunit.energy["move"] != undefined) {
                unit.energy["move"] = deltaunit.energy["move"]
            }
            if(deltaunit.energy["invoke skill"] != undefined) {
                unit.energy["invoke skill"] = deltaunit.energy["invoke skill"]
            }
        }
        if(deltaunit.effects != undefined) {
            Objdict.forEach(deltaunit.effects, (deltaunit, effectKey) => {
                if(deltaunit == undefined) {
                    delete unit.effects[effectKey]
                } else if(unit.effects[effectKey] == undefined) {
                    unit.effects[effectKey] = deltaunit
                } else {
                    unit.effects[effectKey] = Objdict.merge(unit.effects[effectKey], deltaunit)
                }
            })
        }
        if(deltaunit.inventory != undefined) {
            if(deltaunit.inventory.count != undefined) {
                unit.inventory.count += deltaunit.inventory.count
            }
        }
        if(deltaunit.affiliation != undefined) {
            unit.affiliation = deltaunit.affiliation
        }
        return unit
    }
    static editStage(stage, deltastages) {
        if(deltastages instanceof Array == false) {
            deltastages = [deltastages]
        }
        deltastages.forEach((deltastage) => {
            if(deltastage == undefined) {
                return
            }
            if(deltastage.actionMark != undefined) {
                stage.actionMark = deltastage.actionMark
            }
            Objdict.forEach(deltastage.units, (deltaunit, key) => {
                const unit = stage.units[key]
                if(unit == undefined) {
                    if(deltaunit.mode == "create") {
                        stage.units[key] = Unit.instantiate(deltaunit)
                    }
                    return
                }
                if(deltaunit == undefined) {
                    delete stage.units[key]
                    return
                }
                Delta.editUnit(unit, deltaunit, stage)
            })
            if(deltastage.zone != undefined) {
                stage.zone = deltastage.zone
            }
            if(deltastage.turn != undefined
            && deltastage.turn.number != undefined) {
                stage.turn.number += deltastage.turn.number
            }
        })
        return stage
    }
}


// // TODO: also shadow the tiles
// action.shadowtiles = clonedeep(action.shadowtiles)
// if(action.results != undefined) {
//     Object.keys(action.results).forEach((key) => {
//         const result = action.results[key]
//         if(key.substring(0, 5) === "tile:") {
//             const tile = action.shadowtiles.find((tile) => tile.key == key.substring(5))
//             if(tile != undefined) {
//                 return
//             }
//             tile.isBurning = result.isBurning
//             return
//         }
//         // else is unit!!
//     })
// }

// // USED TO BE IN THE ATTACK BEAT PERFORMANCE
// if(key.substring(0, 5) == "tile:") {
//     let position = key.substring(5)
//     let tile = model.game.encounter.stage.map.tiles[position]
//     if(tile == undefined) {
//         return
//     }
//     tile.isBurning = result.isBurning || tile.isBurning
//     return
// }
// if(result.effects) {
//     unit.applyEffects(result.effects)
// }
// if(result.hasPerformedAction != undefined) {
//     if(result.hasPerformedAction == false) {
//         unit.hasPerformedMove = false
//         unit.hasPerformedAttack = false
//         unit.hasPerformedAction = false
//     }
// }

// if(key == "performer") {
//     unit = stage.findUnitByKey(action.performer.key)
// } else if(key == "target") {
//     unit = stage.findUnitByKey(action.target.key)
// }
